// project import
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import Logo from '../../../../assets/images/logos/priseen.jpg';

// third-party
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBar
    sx={{
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column'
      }
    }}
  >
    <Navigation />
    {/* <NavCard /> */}
    {/* <Stack className="items-center justify-center bg-green-50">
      <div className="bottom-center-element fixed bottom-6 w-80 h-80 flex flex-col items-center justify-center bg-green-50">
        <Typography variant="caption" gutterBottom align="center">
          Powered By
        </Typography>
        <img src={Logo} alt="" width={90} height={90} />
      </div>
    </Stack> */}
  </SimpleBar>
);

export default DrawerContent;
